import { IMatch } from "pages/build-test/interfaces";
import { Switch, Route } from "react-router-dom";
import { QuestionIp } from "./routes/question-ip";
import { QuestionIPCreate } from "./routes/question-ip/create";
import { QuestionIPUpdate } from "./routes/question-ip/update";

export const Operations = ({ match }: { match: IMatch }) => {
  return (
    <>
      <Switch>
        <Route exact path={`${match.url}/question_ip`} component={QuestionIp} />
        <Route exact path={`${match.url}/question_ip/create`} component={QuestionIPCreate} />
        <Route exact path={`${match.url}/question_ip/update`} component={QuestionIPUpdate} />
      </Switch>
    </>
  );
};
